export default {
    attack: "attaque",
    specialAttack: "attaque spéciale",
    defense: "défense",
    specialDefense: "défense spéciale",
    speed: "vitesse",
    accuracy: "précision",
    evasion: "esquive"
};